import React, { createContext, useContext } from 'react';

const defaultContext = {
  renderModuleMenu: () => null,
  businessUnits: [],
  businessUnitsLoading: false,
  selectedBusinessUnitId: '',
  selectedBusinessUnitName: '',
  setSelectedBusinessUnitId: () => {},
  canSelectBusinessUnit: true,
  activeViewId: 'dashboard',
};

const ApHubContext = createContext(defaultContext);

export const ApHubProvider = ApHubContext.Provider;

export const useApHub = () => useContext(ApHubContext);

export default ApHubContext;
